import React from 'react';
import { Page } from '../Page';
export function DividerMedication() {
  return <Page hideFooter variant="dark" data-id="element-644" data-mp="1q29xoyfba7be">
      <div className="flex flex-col h-full justify-center items-center text-center" data-id="element-645" data-mp="1q3kxkn5myux8">
        <p className="text-[10px] font-bold text-lightteal uppercase tracking-[0.25em] mb-4" data-id="element-646" data-mp="1v1e3df311mwz">
          Part One
        </p>
        <h1 className="text-5xl font-serif text-white leading-tight mb-6" data-id="element-647" data-mp="1ztxjojt3mw5h">
          Understanding
          <br data-id="element-648" data-mp="24qxoysi4juvj" />
          Your Medication
        </h1>
        <div className="w-16 h-0.5 bg-tealslate" data-id="element-649" data-mp="29qae5jwgxe1a" />
      </div>
    </Page>;
}